import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, IconButton, CircularProgress, Alert, Tooltip } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { getAssinaturas, AssinaturaDigital, getAnexoUrl } from '../services/api';
import { Link } from 'react-router-dom';

const RecibosAssinadosPage: React.FC = () => {
    const [assinaturas, setAssinaturas] = useState<AssinaturaDigital[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchAssinados = async () => {
        try {
            setLoading(true);
            const data = await getAssinaturas('ASSINADO');
            setAssinaturas(data);
        } catch (err: any) {
            setError(err.message || 'Erro ao carregar recibos assinados');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAssinados();
    }, []);

    if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;

    return (
        <Box>
            <Typography variant="h4" gutterBottom>Recibos Assinados (Digitalmente)</Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            
            <Paper>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Data da Assinatura</TableCell>
                                <TableCell>Obra</TableCell>
                                <TableCell>Assinado por</TableCell>
                                <TableCell>Valor</TableCell>
                                <TableCell>IP de Origem</TableCell>
                                <TableCell align="center">Status</TableCell>
                                <TableCell align="right">Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {assinaturas.length === 0 ? (
                                <TableRow><TableCell colSpan={7} align="center">Nenhum recibo assinado digitalmente encontrado.</TableCell></TableRow>
                            ) : assinaturas.map((ass) => {
                                const lanc = ass.lancamentos_financeiros;
                                return (
                                    <TableRow key={ass.id}>
                                        <TableCell>{ass.data_assinatura ? new Date(ass.data_assinatura).toLocaleString('pt-BR') : '-'}</TableCell>
                                        <TableCell>{lanc?.obras?.nome || '-'}</TableCell>
                                        <TableCell>
                                            {ass.nome_assinante} ({ass.metodo_envio === 'sms' && ass.telefone_assinante ? ass.telefone_assinante : (ass.metodo_envio === 'ambos' ? `${ass.email_assinante} / ${ass.telefone_assinante}` : ass.email_assinante)})
                                        </TableCell>
                                        <TableCell>
                                            {lanc?.valor_total_liquido ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(lanc.valor_total_liquido) : '-'}
                                        </TableCell>
                                        <TableCell>{ass.dados_assinatura?.ip_address || '-'}</TableCell>
                                        <TableCell align="center">
                                            <Chip label="Assinado" color="success" size="small" />
                                        </TableCell>
                                        <TableCell align="right">
                                            {ass.arquivo_assinado_path && (
                                                <Tooltip title="Ver PDF do Recibo">
                                                    <IconButton color="primary" component="a" href={getAnexoUrl('anexos', ass.arquivo_assinado_path)} target="_blank">
                                                        <PictureAsPdfIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                            {lanc?.obra_id && (
                                                <Tooltip title="Ver Lançamento na Obra">
                                                    <IconButton component={Link} to={`/obras/${lanc.obra_id}`} color="info">
                                                        <OpenInNewIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};

export default RecibosAssinadosPage;
